import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LesothoFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15398'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15398)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#0C33B8'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#1DB158'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.5233 7.00004C9.67795 6.54536 10.321 6.54536 10.4757 7.00004L11.2713 8.16958C11.362 8.30298 11.3414 8.48048 11.2025 8.56252C10.9745 8.69722 10.5735 8.86671 9.99949 8.86671C9.42552 8.86671 9.02451 8.69722 8.79646 8.56252C8.65754 8.48048 8.63695 8.30298 8.7277 8.16958L9.5233 7.00004Z'
					fill='#262626'
				/>
				<path
					d='M10.6183 6.06663C10.6183 6.39169 10.3475 6.66663 9.99926 6.66663C9.65098 6.66663 9.38021 6.39169 9.38021 6.06663C9.38021 5.74158 9.65098 5.46663 9.99926 5.46663C10.3475 5.46663 10.6183 5.74158 10.6183 6.06663Z'
					stroke='#262626'
					strokeWidth='0.666667'
				/>
			</g>
		</svg>
	);
};

export default LesothoFlagIcon;
